var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({class:_vm.$style.icon,domProps:{"innerHTML":_vm._s(_vm.svgChildren)}},'svg',Object.assign({}, _vm.svgAttributes, {width: '18px', height: '18px'}, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }